import React, { useContext, useState } from "react";
import TimeTableContext from "../../context/timeTableContext";
import TextField from "@material-ui/core/TextField";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { getTodayDateWebview } from "../../helpers/TimeTableHelpers";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Chip from "@material-ui/core/Chip";
import PublicIcon from "@material-ui/icons/Public";
import ReactHtmlParser from "react-html-parser";
import Snackbar from "@material-ui/core/Snackbar";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import "./DistanceLearning.css";
import {
  changeDateFormatDateField,
  dateChangeFromatWebView,
  dateAddSubstractWebView,
} from "../../helpers/TimeTableHelpers";
import { useEffect } from "react";
import { getFileExt } from "../../helpers/TimeTableHelpers";

const SnckBarCustom = (
  { openSnck, handleClickSnck, handleCloseSnck, snckText, time },
) => {
  return (
    <Snackbar
      onClose={handleCloseSnck}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={openSnck}
      autoHideDuration={time}
      message={<div>
        <CancelPresentationIcon
          onClick={handleCloseSnck}
          style={{ color: "white", float: "left" }}
        />
        {snckText}
      </div>}
    />
  );
};

const DistanceLearning = () => {
  const currentUrl = new URL(window.location);

  const context = useContext(TimeTableContext);
  const [expanded, setExpanded] = useState(false);
  const [date, setDate] = useState(getTodayDateWebview()); //
  const [loader, setLoader] = useState(false);
  const [openSnck, setOpenSnck] = useState(false);
  const [snckText, setSnckText] = useState("");
  const [time, setTime] = useState(6000);

  const handleClickSnck = (text) => {
    setSnckText(text);
    setOpenSnck(true);
  };

  const handleCloseSnck = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnck(false);
  };

  const uuid = currentUrl.searchParams.get("uuid");

  const handleChange = (panel) =>
    (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

  useEffect(() => {
    getTimeTableWebview(date);
  }, [date]);

  const getTimeTableWebview = async (date = getTodayDateWebview()) => {
    setLoader(true);
    const debug = currentUrl.searchParams.get("debug");

    const jsonInfo = await fetch(
      `https://${
        debug ? "dev" : "my"
      }.schooly.co.il/app-proxy?query=GetTimeTable&uuid=${uuid}&date=${date}`,
    );

    const objInfo = await jsonInfo.json();
    console.log(objInfo);
    context.dispatch({
      type: "SET_TIMETABLE_WEBVIEW",
      payload: { objInfo: objInfo },
    });
    setLoader(false);
  };

  const setCurrentStudent = async (e) => {
    context.dispatch({
      type: "SET_CURRENT_DISTANCE_USER",
      payload: e.target.value,
    });
  };

  return (
    <div className="distance-learning container">
      <div class="row justify-content-md-center m-2">
        <div class="col-lg-4 col-sm-12">
          <select onChange={setCurrentStudent} class="form-control">
            {context.state
              .timeTableWebViewObj.length > 0
              ? (
                context.state
                  .timeTableWebViewObj.map((elem, key) => {
                    return (<option value={key}>
                      {elem.student_f_name} &nbsp;
                      {elem.student_l_name}
                    </option>);
                  })
              )
              : <option value=""></option>}
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-3 text-left">
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              setDate(dateAddSubstractWebView(date, "minus"));
            }}
          >
            -
          </Button>
        </div>
        <div className="col-6 text-center date-picker">
          <TextField
            id="date"
            type="date"
            format="DD/MM/YYYY"
            defaultValue={changeDateFormatDateField(date)}
            onChange={async (event) => {
              if (Date.parse(event.target.value)) {
                setDate(dateChangeFromatWebView(event.target.value));
              }
            }}
            value={changeDateFormatDateField(date)}
          />
        </div>
        <div className="col-3 text-right">
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              setDate(dateAddSubstractWebView(date, "plus"));
            }}
          >
            +
          </Button>
        </div>
      </div>

      <hr />
      <div>
        {loader
          ? (
            <div className="progress-distance">
              <CircularProgress
                style={{ position: "absolute", top: "150px", zIndex: "999" }}
              />
            </div>
          )
          : context.state
            .timeTableWebViewObj[context.state.currentChildDistanceLearning] &&
            context.state
              .timeTableWebViewObj[context.state.currentChildDistanceLearning]
              .data.length
          ? (
            context.state
              .timeTableWebViewObj[context.state.currentChildDistanceLearning]
              .data.map((elem) => {
                if (context.state.isDebug) {
                  /*
                elem.dFiles = [
                  "//webliran.co.il/files/81s+p-98uyL._SX522_.jpg",
                  "//webliran.co.il/files/CardComInterfaces.pdf",
                  "//webliran.co.il/files/production ID_4836242.mp4",
                  "//webliran.co.il/files/1.pptx",
                  "//webliran.co.il/files/Untitleddocument.doc",
                ];
                */
                }
                return (
                  <Accordion
                    expanded={expanded === `panel + ${elem._id}`}
                    onChange={handleChange(`panel + ${elem._id}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <div style={{ width: "100%" }}>
                        <b>{elem.name}</b>
                        &nbsp;{elem.subject}
                        &nbsp;{elem.classNames}
                        <span className="dContent">
                          {ReactHtmlParser(elem.dContent)}
                        </span>
                        <br />
                        <LinksViewer
                          links={elem.dLinks}
                          showHeader={true}
                          onTask={(text, time) => {
                            setTime(time);
                            setSnckText(text);
                            setOpenSnck(true);
                          }}
                        />
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {elem.dFiles.map((elem) => {
                        return (
                          <div>
                            <Embeder fileName={elem} />
                          </div>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                );
              })
          )
          : (
            <div>אין מידע להצגה</div>
          )}
        <SnckBarCustom
          openSnck={openSnck}
          handleClickSnck={handleClickSnck}
          handleCloseSnck={handleCloseSnck}
          snckText={snckText}
          time={time}
        />
      </div>
    </div>
  );
};

export default DistanceLearning;

const Embeder = ({ fileName }) => {
  let type = getFileExt(fileName);
  const context = useContext(TimeTableContext);

  if (["html"].includes(type)) {
    return (
      <div>
        <EmbedIframe src={fileName} width="100%" />
      </div>
    );
  } else if (["mp4", "mov", "mp3", "webp"].includes(type)) {
    return (
      <div>
        <EmbedVideoFile url={fileName} width="100%" />
      </div>
    );
  } else if (
    ["doc", "docx", "csv", "xls", "xsl", "xslx", "pptx", "ppt", "tsv"].includes(
      type,
    )
  ) {
    return (
      <div>
        <EmbedWordFile url={fileName} width="100%" height="400px" />
      </div>
    );
  } else if (["pdf"].includes(type)) {
    return (
      <div>
        <EmbedPdfFile url={fileName} width="100%" height="400px" />
      </div>
    );
  } else if (["jpg", "jpeg", "png", "svg"].includes(type)) {
    return <EmbedImageFile url={fileName} width="100%" />;
  } else {
    return <span></span>;
  }
};

const EmbedIframe = ({ src, width, height }) => {
  return (
    <iframe
      src={src}
      width={width}
      height={height}
      allowFullScreen
      frameBorder="1"
    >
    </iframe>
  );
};

const getZoomId = (url) => {
  var pageURL = url;
  var pageURLNoQueryString = pageURL.split("?")[0];
  var lastURLSegment = pageURLNoQueryString.substr(
    pageURL.lastIndexOf("/") + 1,
  );
  return lastURLSegment;
};

const copyToClipboard = (text) => {
  var input = document.body.appendChild(document.createElement("input"));
  input.value = text;
  input.focus();
  input.select();
  document.execCommand("copy");
  input.parentNode.removeChild(input);
};

const EmbedVideoFile = ({ url, width }) => {
  return (
    <video width={width} controls>
      <source src={url} type="video/mp4" />
    </video>
  );
};

const EmbedWordFile = ({ url, width, height }) => {
  return (
    <EmbedIframe
      src={`https://view.officeapps.live.com/op/embed.aspx?src=${url}`}
      width={width}
      height={height}
    />
  );
};

const EmbedPdfFile = ({ url, width, height }) => {
  return <EmbedIframe src={url} width={width} height={height} />;
};

const EmbedImageFile = ({ url, width }) => {
  return <img src={url} width={width} />;
};

const LinksViewer = ({ links, showHeader, onTask }) => {
  var type;
  return (
    <span>
      {showHeader && links.length ? "קישורים: " : null}
      {links.map((link) => {
        let { _id, id, name, url, description } = link;

        return (
          <span key={_id} style={{ overflow: "ellipsis" }}>
            {id == -1
              ? (
                <Chip
                  size="small"
                  className="chip-link"
                  label={description || name}
                  icon={<PublicIcon />}
                  onClick={(event) => {
                    event.stopPropagation();
                    onTask(
                      <div>
                        לביצוע המשימה הממוחשבת אנא עבור ל "דף המשימות שלי"
                      </div>,
                      6000,
                    );
                  }}
                  onFocus={(event) => event.stopPropagation()}
                  color="primary"
                  clickable
                />
              )
              : (
                <Chip
                  size="small"
                  className="chip-link"
                  label={description || name}
                  icon={<PublicIcon />}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (id == 100) {
                      //copyToClipboard(url);
                      onTask(
                        <table>
                          <tr>
                            <td>כתובת:</td>
                            <td><input type="text" value={url} readonly /></td>
                            <td>
                              <Button
                                onClick={() => copyToClipboard(url)}
                              >
                                <FileCopyIcon style={{ color: "white" }} />
                              </Button>
                            </td>
                          </tr>
                          <tr>
                            <td>מזהה:</td>
                            <td>
                              <input
                                type="text"
                                value={getZoomId(url)}
                                readonly
                              />
                            </td>
                            <td>
                              <Button
                                onClick={() => copyToClipboard(getZoomId(url))}
                              >
                                <FileCopyIcon style={{ color: "white" }} />
                              </Button>
                            </td>
                          </tr>
                        </table>,
                        10000,
                      );
                    }
                  }}
                  onFocus={(event) => event.stopPropagation()}
                  component={id == 100 ? "div" : "a"}
                  href={id == 100 ? "" : url}
                  target="_blank"
                  color="primary"
                  clickable
                />
              )}
          </span>
        );
      })}
    </span>
  );
};
